import { Pipe, PipeTransform } from '@angular/core';
import { format, formatDistanceToNow, isBefore, isToday } from 'date-fns';
import { FilterOption } from '../interfaces/filter-option.interface';
import { TranslateService } from '@ngx-translate/core';


@Pipe({name: 'getFilterLabel'})
export class GetFilterLabelPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(value: FilterOption[], type: string): string {
    let label = '';
    if (value.length === 0) {
      return type;
    }

    if (value.length > 0) {
      label = `${type}: ${this.translateService.instant(value[0].label)}`;
    }

    if (value.length > 1) {
      label = `${this.translateService.instant(label)} +${value.length-1}`;
    }

    return label;
  }
}
